import { render, staticRenderFns } from "./bulkshipment_tracking.vue?vue&type=template&id=13d2bf72&scoped=true"
import script from "./bulkshipment_tracking.vue?vue&type=script&lang=js"
export * from "./bulkshipment_tracking.vue?vue&type=script&lang=js"
import style0 from "./bulkshipment_tracking.vue?vue&type=style&index=0&id=13d2bf72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2bf72",
  null
  
)

export default component.exports